import { ComponentUtil } from '../../utils/ComponentUtil';
import { Hooks } from '../../types/Hooks';

ComponentUtil.loader(
  !!document.querySelector(Hooks.FilterListRoot),
  () => import('./FilterList'),
  (FilterList) => {
    ComponentUtil.binder(Hooks.FilterListRoot, FilterList);
  },
);
